<template>
  <el-dialog
      :visible.sync="visible"
      title="采购合同修改订单"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
  >
    <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        label-width="120px"
    >
      <el-form-item label="当前订单编号：">
        {{dataForm.oldOrderCode}}
      </el-form-item>
      <el-form-item prop="orderCode" label="新订单：">
        <order-drop v-model="dataForm.orderCode"></order-drop>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible=false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{
          $t('confirm')
        }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'change-order-dialog',
  data () {
    return {
      visible: false,
      dataForm: {},
      dataRule:{
        orderCode:[{ required: true, message: '请输入新订单编号', trigger: 'change' },]
      }
    }
  },
  methods: {
    reset () {
      this.dataForm = {
        id: '',
        orderCode: '',
        oldOrderCode: ''
      }
      if (this.$refs.dataForm) {
        this.$refs.dataForm.clearValidate()
      }
    },
    init (id) {
      this.reset()
      this.dataForm.id = id
      this.getInfo()
      this.visible = true
    },
    async getInfo () {
      if (!this.dataForm.id) {
        return
      }
      const { data: res } = await this.$http.get(`/trade/purchase/${this.dataForm.id}`)
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      }
      this.dataForm.oldOrderCode = res.data.agreementCode

    },
    dataFormSubmitHandle () {
      this.$confirm('采购合同切换订单会同时调整该采购合同下的收货记录, 是否继续?', '操作提示').then(() => {
        if (!this.dataForm.orderCode) {
          return this.$message.error('请选择新订单编号')
        }
        let postForm = {
          id: this.dataForm.id,
          orderCode: this.dataForm.orderCode
        }
        this.$http.post(`/trade/purchase/change/order`, postForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$emit(`refreshDataList`)
          this.visible = false
          this.$message.success('操作成功')
        })
      })
    }
  }
}
</script>

<style scoped>

</style>
